<template>
  <div class="mx-table">
    <Spin size="large" fix v-if="!setting"></Spin>
    <div v-if="setting">
      <slot name="button"></slot>
    </div>
    <Table
      ref="table"
      v-bind="$props"
      v-on="$listeners"
      :columns="columnsHeader"
      :height="height || tableHeight"
      :border="border"
      :loading="loading"
      :draggable="draggable"
      no-data-text="暂无数据"
      no-filtered-data-text="暂无数据"
      :row-class-name="isWarn && isWarn == true ? rowClassName : rowClassNames"
      :class="{ none_border: !border }"
      v-if="setting"
    ></Table>
    <div class="pages" v-if="total">
      <Page
        :total="total"
        :current="current"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40]"
        placement="top"
        show-sizer
        :transfer="true"
        :show-total="showTotal"
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
      ></Page>
    </div>
    <Drawer
      class="setting"
      title="自定义列表"
      v-model="visible"
      :mask-closable="false"
      width="580"
    >
      <p class="info">
        清除浏览器缓存或更换浏览器，自定义设置失效，还原系统默认配置。
      </p>
      <div class="set">
        <CheckboxGroup v-model="columnKeys" class="checkbox" v-if="visible">
          <draggable
            v-model="columnsData"
            animation="300"
            filter=".undraggable"
            :move="onMove"
          >
            <transition-group>
              <template  v-for="item in columnsData">
                <Checkbox
                  v-if="item.title"
                  :label="item.title"
                  :key="item.title"
                  :disabled="item.fixed ? true : false"
                  :class="{ undraggable: item.fixed }"
                >
                  <span class="title">{{ item.title }}</span>
                  <img src="@/assets/img/checkicon.png" />
                </Checkbox>
              </template>
            </transition-group>
          </draggable>
        </CheckboxGroup>
      </div>
      <div class="drawer-footer">
        <Button type="primary" style="margin-right: 8px" @click="save"
          >保存配置</Button
        >
        <Button @click="visible = false">取消</Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  components: { draggable },
  props: {
    columns: {},
    data: Array,
    total: Number,
    loading: Boolean,
    current: Number,
    pageSize: Number,
    height: Number,
    'no-data-text': String,
    stripe: Boolean,
    isWarn: Boolean,
    draggable: Boolean,
    border: {
      type: Boolean,
      default: false,
    },
    showTotal: {
      type: Boolean,
      default: true,
    },
    rowClassName: Function,
  },
  data() {
    return {
      tableHeight: 0,
      columnsHeader: [],
      visible: false,
      setting: true,
      columnKeys: [],
      columnsData: [],
    }
  },
  mounted() {
    const columnsList = Array.from(this.columns)
    this.tableHeight = this.$refs.table.$el.offsetHeight - 47
    let path = this.$route.path
    let data = null
    //获取缓存数据
    let localStorageColumn = localStorage.getItem('columnJson')
    if (localStorageColumn) {
      data = JSON.parse(localStorageColumn)[path]
    }
    var list = []
    if (data && data.length > 0) {
      if (data.find((x) => x.check)) {
        //条件 未选中任意一条表头的展示所有,执行else 否则 if
        data.forEach((item) => {
          var obj = {}
          if (item.fixed) {
            //条件---表格设置fixed属性
            obj = columnsList.find((x) => x.title == item.title)
          } else {
            //条件---勾选的表格check==true属性
            obj = columnsList.find((x) => item.check && x.title == item.title)
          }
          if (obj) {
            list.push(obj)
          }
        })
      } else {
        data.forEach((item) => {
          var obj = {}
          obj = columnsList.find((x) => x.title == item.title)
          if (obj) {
            list.push(obj)
          }
        })
      }
      list = this.filtterColumnsHeaderFun(list)
    } else {
      list = this.filtterColumnsHeaderFun(columnsList)
    }
    this.columnsHeader = list
  },
  methods: {
    onMove(event) {
      //拖拽事件处理
      const draggedElement = event.dragged
      //目标被替换的元素
      const targetElement = event.related
      if (
        targetElement.classList.contains('undraggable') ||
        draggedElement.classList.contains('undraggable')
      ) {
        // 阻止拖拽
        return false
      }
    },
    save() {
      let path = this.$route.path
      const that = this
      let data = {}
      var list = []
      const columnsList = Array.from(this.columnsData)
      columnsList.map((item) => {
        if (item.fixed && this.columnKeys.length != 0) {
          list.push(item)
        } else if (this.columnKeys.find((x) => x == item.title)) {
          list.push(item)
          item.check = true
        } else {
          item.check = false
        }
        return item
      })
      data[path] = columnsList
      localStorage.setItem('columnJson', JSON.stringify(data))
      if (list.length == 0) {
        this.columnsHeader = this.filtterColumnsHeaderFun(columnsList)
      } else {
        this.columnsHeader = this.filtterColumnsHeaderFun(list)
      }
      this.setting = false
      this.visible = false
      setTimeout(() => {
        //iview动态表头死循环处理
        that.setting = true
      }, 1000)
    },
    filtterColumnsHeaderFun(data) {
      return data.map((item, index) => {
        if (index == data.length - 1) {
          item.renderHeader = (h, { column }) => {
            return h('div', [
              h('span', column.title),
              h('img', {
                attrs: {
                  src: require('@/assets/img/setting.svg'),
                },
                style: {
                  width: '18px',
                  height: '18px',
                  position: 'absolute',
                  right: '15px',
                  cursor: 'pointer',
                },
                on: {
                  click: () => {
                    this.setColumns()
                  },
                },
              }),
            ])
          }
        } else {
          item.renderHeader = (h, { column }) => {
            return h('div', [h('span', column.title)])
          }
        }
        return item
      })
    },
    setColumns() {
      let path = this.$route.path
      const columnsList = Array.from(this.columns) //原始数据
      let localStorageColumn = localStorage.getItem('columnJson')
      var data = JSON.parse(localStorageColumn) //缓存数据
      if (localStorageColumn && data[path] && data[path].length > 0) {
        var keys = []
        data[path].forEach((x) => {
          if (x.check) {
            keys.push(x.title)
          }
        })
        this.columnKeys = keys //默认勾选数据赋值
        const list = data[path].map((item) => {
          var obj = {}
          columnsList.forEach((x) => {
            if (x.title == item.title) {
              obj = x
            }
          })
          return { ...obj, check: item.check }
        })
        this.columnsData = list //缓存数据比对原始数据;属性title相同则从原始数据抽取并添加
      } else {
        columnsList.forEach((x) => {
          this.columnKeys.push(x.title)
        })
        this.columnsData = columnsList
      }
      this.visible = true
    },
    pageChange(pageChanged) {
      this.$emit('pageChange', pageChanged)
    },
    sizeChange(sizeChanged) {
      this.$emit('sizeChange', sizeChanged)
    },
    selectAll(status) {
      this.$refs.table.selectAll(status)
    },
    // rowClassName(row) {
    //   if (row.rejected || row.rejected == true) {
    //     return 'demo-table-info-row'
    //   } else {
    //     return ''
    //   }
    // },
    rowClassNames() {
      return ''
    },
  },
}
</script>
<style lang="less" scoped>
.mx-table {
  width: 100%;
  display: flex;
  flex-flow: column;
  flex: auto;
  background: #fff;
  padding: 0 24px 16px 24px;
  border-radius: 0 0 6px 6px;
  position: relative;
  /deep/.ivu-table-wrapper {
    flex: auto;
    .ivu-table:before {
      display: none;
    }
    /deep/.none_border {
      .ivu-table th,
      .ivu-table td {
        border: none;
      }
    }
  }
  /deep/.ivu-table th{
    background-color: #F7F7F7;
  }
  .pages {
    margin-top: 15px;
    text-align: right;
    /deep/.ivu-page-total {
      float: left;
    }
  }
}
.setting {
  .drawer-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: left;
    background: #fff;
  }
  .set {
    overflow: hidden;
    overflow-y: auto;
    height: calc(100% - 60px);
  }
}
.checkbox {
  .info {
    color: #87898b;
  }
  /deep/.ivu-checkbox-group-item {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row-reverse;
    border-bottom: 1px solid #e6e6e6;
  }
  /deep/.ivu-checkbox {
    float: right;
  }
  .title {
    flex: auto;
    margin-left: 16px;
    font-size: 16px;
    color: #000000;
  }
}
</style>
